import styled from 'styled-components';

import Icon from 'components/Icon';

const Container = styled.div`
	position: relative;
	outline: none;
`;

const Tip = styled.div`
  background-color: ${props => props.theme.main};
	border: 0px;
	color: white;
	text-align: center;
  box-shadow: 0px 5px 20px -8px ${props => props.theme.main};
  border-radius: 20px;
  padding: 5px 16px 4px 16px;
  position: relative;
  cursor: pointer;
	font-size: 14px;
	word-break: normal;
  position: absolute;
  ${props => props.position === 'left' ? 'top: 50%;' : 'bottom: 100%;'}
  ${props => props.position === 'left' ? 'right: 100%;' : 'left: 50%;'}
  opacity: 0;
  transform: ${props => props.position === 'left' ? 'translateX(-4px) translateY(-50%)' : 'translateX(-50%) translateY(-4px)'};
  transition: all 0.2s ease-out;
	pointer-events: none;
	z-index: 100;
	${props => props.position === 'left' ? 'white-space: nowrap;' : ''}
	outline: none;

  &:after {
    content: '';
    display: block;
    width: 0px;
    height: 0px;
    border: 5px solid rgba(0,0,0,0);
    border-${props => props.position === 'left' ? 'left' : 'top'}-color: ${props => props.theme.main};
    position: absolute;
    top: ${props => props.position === 'left' ? '49%;' : '100%;'};
    left: ${props => props.position === 'left' ? '99%;' : '50%'};
    transform: ${props => props.position === 'left' ? 'translateY(-50%)' : 'translateX(-50%)'};
  }

  ${Container}:hover & {
		opacity: 1;
		transform: ${props => props.position === 'left' ? 'translateX(-7px) translateY(-50%)' : 'translateX(-50%) translateY(-7px)'};
  }
`;

const TooltipIcon = styled(Icon)`
  fill: ${props => (props.spin === 1 ? props.theme.main : props.fill) || '#D2D9E5'};
  width: 20px;
  height: 20px;
  padding: 0;
  cursor: pointer;
  border: 0px;
  background: none;
	appearance: none;
	animation: ${props => props.spin === 1 ? 'spin 0.75s linear infinite' : 'none'};
	outline: none;

  ${Container}:hover & {
    fill: ${props => props.theme.main};
	}

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}
`;

export {
	Container,
	Tip,
	TooltipIcon,
}
